import {
    DefaultButton,
    Dropdown,
    IDropdownOption,
    mergeStyleSets,
    Stack,
    Text
} from "@fluentui/react"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

import { L10n } from "@encoway/l10n"

import { getCatalogService } from "../app/catalogServiceHolder"
import { setCountry } from "../app/configurationSlice"
import { useAppDispatch } from "../app/hooks"
import { TranslationConstants } from "../constants/translationConstants"

const buttonStyles = mergeStyleSets({
    root: {
        backgroundColor: "#6ec800",
        borderRadius: "0",
        color: "#1f2837",
        fontSize: "1rem",
        fontWeight: 700,
        border: "2px solid transparent"
    },
    rootHovered: {
        backgroundColor: "#6ec800",
        borderTopColor: "transparent",
        borderRightColor: "#1f2837",
        borderBottomColor: "#1f2837",
        borderLeftColor: "transparent"
    },
    rootFocused: {
        backgroundColor: "#6ec800",
        borderTopColor: "#1f2837",
        borderRightColor: "transparent",
        borderBottomColor: "transparent",
        borderLeftColor: "#1f2837"
    }
})

export function SalesContextSelector() {
    const [selectedCountry, setSelectedCountry] = useState<IDropdownOption>()
    const [countryOptions, setCountryOptions] = useState<IDropdownOption[]>()

    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    async function fetchCountries() {
        const catalogService = getCatalogService()
        const countries = await catalogService.characteristic("COUNTRY")
        if (countries.possibleValues) {
            console.error("No countries found in catalog service")
            setCountryOptions(
                Object.values(countries.possibleValues).map((country) => ({
                    key: country.id,
                    text: String(country.value)
                }))
            )
            const defaultCountry = countries.possibleValues.GLOBAL
            if (defaultCountry) {
                setSelectedCountry({
                    key: defaultCountry.id,
                    text: String(defaultCountry.value)
                })
            }
        }
    }

    function handleClick() {
        console.log("Weiter button clicked")
        if (selectedCountry) {
            dispatch(setCountry(String(selectedCountry.key)))
            navigate("/configurator")
        }
    }

    useEffect(() => {
        fetchCountries()
    }, [])

    return (
        <Stack tokens={{ padding: 20, childrenGap: 20 }}>
            <Stack>
                <Text variant="large">
                    {L10n.format(
                        TranslationConstants.SalesContextSelector.HEADLINE
                    )}
                </Text>
                <Text>
                    {L10n.format(
                        TranslationConstants.SalesContextSelector.DESCRIPTION
                    )}
                </Text>
            </Stack>

            <Stack
                horizontalAlign="start"
                tokens={{ childrenGap: 10 }}
                horizontal
            >
                <Dropdown
                    selectedKey={selectedCountry?.key}
                    options={countryOptions || []}
                    placeholder={L10n.format(
                        TranslationConstants.SalesContextSelector.PLACEHOLDER
                    )}
                    onChange={(_, item) => {
                        setSelectedCountry(item)
                    }}
                    styles={{
                        dropdown: { width: 280 }
                    }}
                />

                <DefaultButton
                    onClick={handleClick}
                    styles={buttonStyles}
                    disabled={!selectedCountry}
                >
                    {L10n.format(
                        TranslationConstants.SalesContextSelector
                            .CONTINUE_BUTTON
                    )}
                </DefaultButton>
            </Stack>
        </Stack>
    )
}
